export default __webpack_public_path__ + "static/media/13_gallery.d87d0e97.jpg";